import Flickity from 'flickity';

const init = () => {
  window.catalogEntryGalleryNav = null;

  const carousel = document.querySelector('.product-carousel-nav');

  if (!carousel) {
    return;
  }

  let params = carousel.dataset.flickityInitParams;
  
  const allowProductGalleryNavDrag = (e) => {
    
    if (!window.catalogEntryGalleryNav) {
      return;
    }
    
    const isDragDisabled = window.catalogEntryGalleryNav.size.width > window.catalogEntryGalleryNav.slideableWidth;
    
    if (isDragDisabled) {
      window.catalogEntryGalleryNav.select(0);
      window.catalogEntryGalleryNav.isDraggable = false;
    } else {
      window.catalogEntryGalleryNav.isDraggable = true;
    }
    
  }
  
  try {
    params = JSON.parse(params);
    window.catalogEntryGalleryNav = new Flickity(carousel, params);
    allowProductGalleryNavDrag();
    let resizeId;

    window.addEventListener('resize', () => {
      clearTimeout(resizeId);
      resizeId = setTimeout(allowProductGalleryNavDrag, 500);
    });
  } catch(err) {
      console.warn(`Flickity slider: Can't initialize`, err);
  }



}

export default init;